import { CampaignErrorsInterface } from 'modules/campaigns/types/campaign-interface'

export const defaultCampaignErrors: CampaignErrorsInterface = {
  name: '',
  description: '',
  senderEmailAddress: '',
}
